import { Component, OnInit } from '@angular/core';
import { ScreenSize } from '../../shared/shared.reducer';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.reducer';

@Component({
  selector: 'product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
})
export class ProductComponent implements OnInit {
  screenSize: ScreenSize;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.store.select('shared').subscribe(store => {
      this.screenSize = store.screenSize;
    });
  }
}
